import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-animated-modal";
import { PulseLoader } from 'halogenium';
import { kiplePaymentCodes } from '../../app/Common/Enum/KiplePaymentCode';

var portalRoot = null;

class SelectOneFromManyModalPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#select-one-from-many-modal-portal').length == 0) {
            $('body').prepend('<div id="select-one-from-many-modal-portal" style="position: absolute; z-index: 1501"></div>')
        }
        portalRoot = document.getElementById("select-one-from-many-modal-portal");
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        portalRoot.removeChild(this.el);
    };
    onClose = () => {}
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}
class SelectOneFromManyModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        }
    }
    isLoading(isLoading, callback) {
        if (!this.unmounted) {
            this.setState({isLoading}, () => {callback && callback()})
        }
    }
    componentWillUnmount = () => {
        this.unmounted = true;
        $(document).unbind('keypress', this.enterKeyListener)
        $(document).unbind('keyup',this.escListener);
    };
    componentDidMount = () => {
        // Set reference to that can be removed at componentWillUnmount
        this.enterKeyListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                this.props.onYes && this.props.onYes()
            }
        }
        this.escListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '27'){
                this.props.onNo && this.props.onNo()
            }
        }
        this.unmounted = false
        $(document).keypress(this.enterKeyListener);
        $(document).keyup(this.escListener);

    };
    onClose = () => {}

    // Parent to call this to dismiss the modal
    close() {
        this.props.onClose()
    }
    getButtons = () => {
        return <div className="mt-3">{
            this.props.choices.map((choice) => {
                return <button key={choice.value} id={`select-1-from-n-choice-${choice.value}`} onClick={() => this.props.onChoiceSelected(choice)} className={"btn btn-block btn-default mb-2"}>
                    {choice.label}
                </button>
            })
        }</div>
    }
    render() {
        return (
            <SelectOneFromManyModalPortal>
                <Modal
                    visible={true}
                    closemodal={this.props.onClose}
                    type="pulse">
                    <div className="menu-modal" style={{padding:"20px"}}>
                        <div>
                            {this.props.message}
                        </div>
                        { 
                            this.state.isLoading ? 
                            <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "center" }} /> :
                            this.getButtons()
                        }
                    </div>
                </Modal>
            </SelectOneFromManyModalPortal>
        )
    }
}
SelectOneFromManyModal.defaultProps = {
    message: "",
    buttonLayout: "default",
    isYesDestructive: false,
    choices: [],
}
export default SelectOneFromManyModal;